<div class="second-level-nav">
	<ul>
		<li
			*ngFor="let widgetNavItem of widgetNavItems; let index = index; let last = last"
			(click)="navigateToWidget(index, widgetNavItem)"
			[ngClass]="{ 'nav-active': index === activeIndex }"
			class="{{ widgetNavItem }}"
		>
			<span>{{ widgetNavItem }}</span>
		</li>
	</ul>
</div>
